import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaPropertyHeading.vue.script.js";
/* empty css                                    */
//#region src/schema/SchemaPropertyHeading.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-d9e2f10e"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaPropertyHeading.vue.js.map